module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "settings-header pt-3 pl-3 grey lighten-4",
    attrs: {
      "id": "notifications-header"
    }
  }, [_c('h1', {
    attrs: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "mr-3 icon icon-bell"
  }), _vm._v("\n      " + _vm._s(_vm.$t('notifications.header-title')) + "\n    ")]), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "flat": "",
      "dense": "",
      "height": "35px"
    }
  }, [_c('v-toolbar-items', [_c('v-btn', {
    class: {
      'current_page': _vm.$route.path === '/settings/XXXXXXX'
    },
    attrs: {
      "flat": ""
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('notifications.header-preset')))])]), _vm._v(" "), _c('v-btn', {
    class: {
      'current_page': _vm.$route.path === '/settings/notifications_mail'
    },
    attrs: {
      "flat": "",
      "to": "/settings/notifications_mail"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('notifications.header-mail')))])])], 1)], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-7d573bdb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = 1939
// module chunks = 0